// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#newBack {

}

#newBack {

}

#newIntro {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 42px;
    max-width: 270px;
    display: block;
}

#newButtonScan {
    font-size: 12px;
    margin-top: 60px;

}

.qrcodesvg {
    position: relative;
}

.qrcodesvg svg{
    margin: 0 auto;
    width: 100%;
}

.qrcodesvg video {
    width: 100%;
    position: absolute;
    height: 100%;
    top: 0;
    left: 0;
}

#newBack {
    position: absolute;
    top: 15px;
    font-weight: bold;
    color: var(--footer-selected-color);
    text-transform: uppercase;
    font-size: 10px;
}

#newBack svg {
    margin-right: 9px;
}

#newTitle {
    margin-top: 0;
    font-family: Silvana;
    font-weight: 300;
    font-size: 60px;
    color: var(--main-link-color);
    line-height: 1em;
    margin-bottom: 24px;
}

#newManual {

}

#newButtonNew {
    font-size: 12px;
}

#newSerialNumber {

}

.paddingBottom {
    margin-bottom: 24px;
}

.formNew {
    max-width: 80%;
    justify-content: center;
    margin: 0 auto;
    width: 75%;
}

.parent-container {
    overflow-y: auto;
    max-height: 100%;
}


.btnWallet{
    background: rgb(255, 158, 23);
    color: white;
}

.btnWallet:hover{
    color: white;

}

.btnWalletReverse{
    border: 1px solid rgb(255, 158, 23);
    background: white;
    color: rgb(255, 158, 23);
}

.btnWalletReverse:hover{
    color: rgb(255, 158, 23);

}
.btn:focus {
    box-shadow: none!important;
}

.showError {
    border: 1px solid rgb(255, 158, 23);
    border-radius: 5px;
    background-color: rgba(255, 158, 23, 0.3);
    padding: 5px;
}

.newLanguage {
    position: absolute;
    top: 15px;
    right:25px
}

.topQrModal {
    margin-bottom: 5px;
    min-height: 60px;
    display: flex;
    justify-content: space-between;
}

.flash {
    background-color: white;
    border: black solid 2px;
    border-radius: 5px;
    width: 50px;
    height: 50px;
    color: black;
    font-size: 25px;
}

.flashOn {
    border-color: rgb(255, 158, 23);
    color: rgb(255, 158, 23);
}`, "",{"version":3,"sources":["webpack://./src/styles/new.css"],"names":[],"mappings":"AAAA;;AAEA;;AAEA;;AAEA;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;;AAEpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,MAAM;IACN,OAAO;AACX;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,iBAAiB;IACjB,mCAAmC;IACnC,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;AAEA;;AAEA;IACI,eAAe;AACnB;;AAEA;;AAEA;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,uBAAuB;IACvB,cAAc;IACd,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;;AAGA;IACI,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,YAAY;;AAEhB;;AAEA;IACI,mCAAmC;IACnC,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;;AAE5B;AACA;IACI,0BAA0B;AAC9B;;AAEA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,yCAAyC;IACzC,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,wBAAwB;AAC5B","sourcesContent":["#newBack {\n\n}\n\n#newBack {\n\n}\n\n#newIntro {\n    font-size: 16px;\n    font-weight: 500;\n    margin-bottom: 42px;\n    max-width: 270px;\n    display: block;\n}\n\n#newButtonScan {\n    font-size: 12px;\n    margin-top: 60px;\n\n}\n\n.qrcodesvg {\n    position: relative;\n}\n\n.qrcodesvg svg{\n    margin: 0 auto;\n    width: 100%;\n}\n\n.qrcodesvg video {\n    width: 100%;\n    position: absolute;\n    height: 100%;\n    top: 0;\n    left: 0;\n}\n\n#newBack {\n    position: absolute;\n    top: 15px;\n    font-weight: bold;\n    color: var(--footer-selected-color);\n    text-transform: uppercase;\n    font-size: 10px;\n}\n\n#newBack svg {\n    margin-right: 9px;\n}\n\n#newTitle {\n    margin-top: 0;\n    font-family: Silvana;\n    font-weight: 300;\n    font-size: 60px;\n    color: var(--main-link-color);\n    line-height: 1em;\n    margin-bottom: 24px;\n}\n\n#newManual {\n\n}\n\n#newButtonNew {\n    font-size: 12px;\n}\n\n#newSerialNumber {\n\n}\n\n.paddingBottom {\n    margin-bottom: 24px;\n}\n\n.formNew {\n    max-width: 80%;\n    justify-content: center;\n    margin: 0 auto;\n    width: 75%;\n}\n\n.parent-container {\n    overflow-y: auto;\n    max-height: 100%;\n}\n\n\n.btnWallet{\n    background: rgb(255, 158, 23);\n    color: white;\n}\n\n.btnWallet:hover{\n    color: white;\n\n}\n\n.btnWalletReverse{\n    border: 1px solid rgb(255, 158, 23);\n    background: white;\n    color: rgb(255, 158, 23);\n}\n\n.btnWalletReverse:hover{\n    color: rgb(255, 158, 23);\n\n}\n.btn:focus {\n    box-shadow: none!important;\n}\n\n.showError {\n    border: 1px solid rgb(255, 158, 23);\n    border-radius: 5px;\n    background-color: rgba(255, 158, 23, 0.3);\n    padding: 5px;\n}\n\n.newLanguage {\n    position: absolute;\n    top: 15px;\n    right:25px\n}\n\n.topQrModal {\n    margin-bottom: 5px;\n    min-height: 60px;\n    display: flex;\n    justify-content: space-between;\n}\n\n.flash {\n    background-color: white;\n    border: black solid 2px;\n    border-radius: 5px;\n    width: 50px;\n    height: 50px;\n    color: black;\n    font-size: 25px;\n}\n\n.flashOn {\n    border-color: rgb(255, 158, 23);\n    color: rgb(255, 158, 23);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
